/* =====================================================================
   MÁQUINA EXPENDEDORA DE PREMIOS · CONFIGURACIÓN
   ---------------------------------------------------------------------
   Lo usan la página de la máquina y el "guardián" del carrito,
   que se carga en toda la tienda.

   En Shopify ya está creado:
   · Descuento "Máquina expendedora de premios (19–25 oct)", código
     MAQUINA-DE-PREMIOS: 100 % en 1 premio, compra mínima $20 de la
     colección "maquina-elegibles", 1 por pedido, no se combina.
   · Colección automática "maquina-elegibles": todo lo que NO es de
     tipo "Premio dinámica".
   · Los 2 premios están "ocultos" (no salen en colecciones ni búsqueda).

   Fechas en hora de Ecuador: "desde" 00:00 y "hasta" 23:59.
   ===================================================================== */
window.COCO_MAQUINA = {
  desde: "2026-10-19",
  hasta: "2026-10-25",
  zonaHoraria: "-05:00",
  minimo: 20, // dólares en productos elegibles
  codigo: "MAQUINA-DE-PREMIOS",
  // Código para probar el checkout en el tema de vista previa antes del 19 (vacío = no hay)
  codigoPrueba: "",
  marcaLinea: "_maquina", // propiedad oculta que identifica el regalo en el carrito
  seguirComprando: "/collections",
  whatsapp: "https://wa.link/qa5mms",

  premios: [
    {
      id: "anillo",
      nombre: "Anillo sorpresa",
      articulo: "un",
      tipo: "anillo",
      handle: "anillo-sorpresa-💍",
      producto: 10339212787874,
      variante: 50613570470050,
      precio: 15,
      imagen: "https://cdn.shopify.com/s/files/1/0523/6103/5938/files/IMG-6172.png?v=1791926823",
      detalle: "Una joyita elegida por nosotras, lista para estrenar.",
            tallas: ["6", "7", "8", "Ajustable"], // la clienta elige una antes de reclamar
      probabilidad: 50,
    },
    {
      id: "collar",
      nombre: "Collar sorpresa",
      articulo: "un",
      tipo: "collar",
      handle: "collar-sorpresa-💍",
      producto: 10339213181090,
      variante: 50613570797730,
      precio: 16,
      imagen: "https://cdn.shopify.com/s/files/1/0523/6103/5938/files/IMG-6174.png?v=1791927045",
      detalle: "Un collar delicado con dije sorpresa.",
      probabilidad: 50,
    },
  ],

  condiciones: [
    "Válido del 19 al 25 de octubre de 2026.",
    "Necesitas al menos $20 en productos de la tienda (el premio no cuenta).",
    "Un premio por pedido y una cápsula por persona.",
    "El premio se agrega a $0 y no se acumula con otros códigos o promociones.",
    "Si tu carrito baja de $20, el regalo se retira hasta que vuelvas a llegar.",
    "Hasta agotar stock.",
  ],
};
